import ElementController from "../base-controllers/ElementController.js";
/** Ensure targets inside the app's scroll container are visible after navigation. */
class ScrollToHash extends ElementController {
    load() {
        if (window.location.hash !== `#${this.root.id}`)
            return;
        this.root.scrollIntoView({
            behavior: "instant",
            block: "center",
        });
    }
}
ScrollToHash.id = "ScrollToHash";
export default ScrollToHash;
//# sourceMappingURL=ScrollToHash.js.map